import React from "react";
import styled from "styled-components";

const NextBtn = styled.div`
  width: 250px;
  height: 60px;
  background-color: mediumpurple;
  padding: 10px;
  text-align: center;
  margin: auto;
  position: absolute;
  bottom: 50px;
  left: 50%;
  transform: translate(-50%, 0);
  border-radius: 30px;
  border: 1px solid #fff;
  outline: none;
`

const NextBtnInnerBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  
  span {
    font-size: 20px;
    line-height: 22px;
  }
`

const DetailButton = ({func}) => {
    return (
        <NextBtn>
            <NextBtnInnerBlock onClick={func}>
                <span>Подробнее</span>
            </NextBtnInnerBlock>
        </NextBtn>
    )
}

export default DetailButton